import { createActions } from 'redux-actions';
import { Garage } from '@models/BusinessPartner';
import { GarageNetworkSearchParams } from '@apis/GarageNetworkApi';
import { Pagination } from '@models/Pagination';

export type State = {
  garages?: Garage[] | null;
  isLoading?: boolean;
  error?: string | null;
  pagination?: Pagination | null;
  searchParams?: GarageNetworkSearchParams;
};

export type StateUpdatePayload = Partial<State>;

export type GaragesFetchPayload = GarageNetworkSearchParams;

export const {
  garagesFetch,
  stateUpdate,
} = createActions(
  'GARAGES_FETCH',
  'STATE_UPDATE',
  {
    prefix: 'GARAGE_NETWORK_PAGE',
  },
);
